/**
 * Chrome ignores autocomplete="off" on a site with a saved login and writes the
 * email (or an old form value) into the first text field. Search boxes were
 * sending that string as the product query.
 *
 * Keep the field readonly until the user actually clicks it, give it a new name
 * on each load so saved form data cannot match, and drop any value that arrives
 * without a keystroke, paste, or drop.
 */
import Vue from 'vue'

var styleInjected = false

function injectStyle () {
  if (styleInjected || typeof document === 'undefined') return
  styleInjected = true
  var style = document.createElement('style')
  style.textContent = [
    '@keyframes sk-autofill-start { from { opacity: 1 } to { opacity: 1 } }',
    'input[data-sk-search]:-webkit-autofill { animation-name: sk-autofill-start; animation-duration: 1ms; }',
    'input[data-sk-search] { -webkit-appearance: textfield; appearance: textfield; }',
    'input[data-sk-search][readonly] { cursor: text; background-color: #fff !important; opacity: 1; }',
    'input[data-sk-search]::-webkit-search-decoration,',
    'input[data-sk-search]::-webkit-search-cancel-button,',
    'input[data-sk-search]::-webkit-search-results-button,',
    'input[data-sk-search]::-webkit-search-results-decoration { -webkit-appearance: none; display: none; }'
  ].join('\n')
  document.head.appendChild(style)
}

function wanted (binding) {
  if (!binding || !Object.prototype.hasOwnProperty.call(binding, 'value')) return null
  if (binding.value == null) return ''
  return String(binding.value)
}

function remember (el, binding) {
  var want = wanted(binding)
  el._skAccepted = want == null ? (el.value || '') : want
}

function markUser (el) {
  el._skUserEdited = true
  el.removeAttribute('readonly')
}

function rejectUnsolicited (el) {
  if (el._skUserEdited) {
    el._skAccepted = el.value
    return
  }
  var accepted = el._skAccepted == null ? '' : el._skAccepted
  if (el.value === accepted) return
  el._skRejecting = true
  el.value = accepted
  el._skRejecting = false
}

function unlock (el) {
  el.removeAttribute('readonly')
}

export default {
  bind: function (el, binding) {
    injectStyle()
    el.setAttribute('data-sk-search', 'true')
    el.setAttribute('autocomplete', 'off')
    el.setAttribute('autocorrect', 'off')
    el.setAttribute('autocapitalize', 'none')
    el.setAttribute('spellcheck', 'false')
    el.setAttribute('data-lpignore', 'true')
    el.setAttribute('data-1p-ignore', 'true')
    el.setAttribute('data-bwignore', 'true')
    el.setAttribute('data-form-type', 'other')
    el.setAttribute('name', 'sk-q-' + Math.random().toString(36).slice(2))
    el.setAttribute('readonly', 'readonly')
    el._skUserEdited = false
    el._skRejecting = false
    remember(el, binding)

    el.addEventListener('pointerdown', function () { unlock(el) })
    el.addEventListener('keydown', function () { markUser(el) })
    el.addEventListener('paste', function () { markUser(el) })
    el.addEventListener('drop', function () { markUser(el) })
    el.addEventListener('focus', function () {
      unlock(el)
      setTimeout(function () { rejectUnsolicited(el) }, 0)
      setTimeout(function () { rejectUnsolicited(el) }, 250)
      setTimeout(function () { rejectUnsolicited(el) }, 800)
    })
    // Capture runs before Vue's v-model listener, so the model never sees the filled value.
    el.addEventListener('input', function () { rejectUnsolicited(el) }, true)
    el.addEventListener('change', function () { rejectUnsolicited(el) }, true)
    el.addEventListener('animationstart', function (e) {
      if (e.animationName === 'sk-autofill-start') rejectUnsolicited(el)
    })
  },
  inserted: function (el, binding) {
    Vue.nextTick(function () {
      if (el._skUserEdited || el._skRejecting) return
      remember(el, binding)
      rejectUnsolicited(el)
    })
  },
  componentUpdated: function (el, binding) {
    if (el._skUserEdited || el._skRejecting) return
    remember(el, binding)
    if (el.value !== el._skAccepted) el.value = el._skAccepted
  }
}



// WEBPACK FOOTER //
// ./src/directives/preventAutofill.js